import { BACKEND_BASE_URL, BACKEND_BASE_URL_READS, TransactionService } from "@/services";
import Vue from "vue";
import { RawTransactions, TransactionDefaultFields, Transactions, TransactionSearchConfig } from "@/entities";
import { Filter, OrderByFields, PageRequest } from "../backend.types";
import { AxiosRequestConfig } from "axios";

export class TransactionServiceImpl implements TransactionService {
  async fetchTransactions(
    limit: number,
    offset: number,
    sortFields: OrderByFields[],
    filters: Filter[]
  ): Promise<Transactions> {
    const url = `${BACKEND_BASE_URL_READS}/api/v2/me/transactions`;
    const body: PageRequest = { limit, offset, sortFields, filters };
    const { data } = await Vue.$axios.post<RawTransactions>(url, body);
    return new Transactions(data);
  }
  async fetchTransactionsFileExport(
    sortFields: OrderByFields[],
    filters: Filter[],
    fields: { field: string; label: string; orderId: string }[],
    translations: { field: string; translation: { [key: string]: string } }[],
    selectTypeExport: string,
    delimiter: string,
    decimalFormat = "US"
  ): Promise<File> {
    const url = `${BACKEND_BASE_URL_READS}/api/v3/me/transactions/export`;
    var language = 'en';
    if (navigator.language) {
     language = navigator.language;
     }
  
    const body = {
      sortFields,
      filters,
      reportFields: fields,
      translations,
      typeExport: selectTypeExport,
      typeDelimiter: delimiter,
      language: language,
      decimalFormat: decimalFormat,
    };
    const responseType: AxiosRequestConfig = { responseType: "blob" };
    const response = await Vue.$axios.post(url, body, responseType);
    const contentType = response.headers["content-type"];
    const filename = response.headers["content-disposition"].split("filename=")[1].split(";")[0];
    const blob = new Blob([response.data as BlobPart], {
      type: contentType,
    });
    return new File([blob], filename);
  }

  async fetchSearchConfig(): Promise<TransactionSearchConfig> {
    const { data } = await Vue.$axios.get(`${BACKEND_BASE_URL_READS}/api/v1/transactions/search-config`);

    return new TransactionSearchConfig(data);
  }

  async fetchDefaultFields(): Promise<TransactionDefaultFields> {
    const { data } = await Vue.$axios.get(`${BACKEND_BASE_URL}/api/v1/page-default`);
    return new TransactionDefaultFields(data);
  }
}
